import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { PostRegistrationTutorialState } from './postRegistrationTutorialState';
import { Window, WindowHeader } from '../../../components/overlays';
import { Button } from '../../../components';
import { usePopper } from 'react-popper';

import '../authPages.scss';

type Props = {
  model: PostRegistrationTutorialState;
  visible?: boolean;
};

const tutorialTips = [
  <span>
    If a dedicated Library has been created for you, please go to{' '}
    <strong>My Libraries</strong> and upload from within your named Library
  </span>,
  <span>
    Create a bookmark list to save moments in <strong>MY Bookmarks</strong>
  </span>,
  <span>
    In Public Safety search for your name in <strong>My Libraries</strong> and
    upload in your library
  </span>,
];

export const PostRegistrationTutorialWindow = observer((props: Props) => {
  const { model } = props;

  const isMobile = !!model?.store.ui.isMobile;

  const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(
    null,
  );
  const anchorElement = document.querySelector('[data-navitem=myUploads]');
  const { styles } = usePopper(anchorElement, popperElement, {
    placement: 'right',
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: isMobile ? [-520, -80] : [-180, 0],
        },
      },
    ],
  });
  return (
    <Window
      innerRef={setPopperElement}
      className="register-tutorial-window"
      model={model.window}
      style={styles.popper}
      visible={props.visible}
    >
      <WindowHeader model={model.window} title="Get started with Clipr" />

      <section className="tutorial-content">
        <div
          className="tutorial-boxes"
          aria-label="Upload and bookmark guidance"
        >
          <div className="tutorial-arrows">
            <span className="tutorial-arrow top" />
            <span className="tutorial-arrow middle" />
            <span className="tutorial-arrow bottom" />
          </div>

          <div className="tutorial-tip-list">
            {tutorialTips.map((tip, index) => (
              <div className="tutorial-tip" key={index}>
                <p>{tip}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="tutorial-player">
          {!isMobile && <p className="text">OR</p>}
          <strong>Play with this sample to see how CLIPr works</strong>
          <img
            className="tutorial-player-img"
            src="/img/signup-player.png"
            alt="CLIPr Player"
          />

          {!isMobile && (
            <Button
              route="/user/video/84667f95-a01b-46dd-8b5e-7020d300f216?teamId=0128e44d-f5e2-44ce-8041-cecc7bbdd59a"
              target="_blank"
              className="secondary medium"
              label="Get Started"
            />
          )}
        </div>
      </section>
    </Window>
  );
});
